import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { AuthService } from '@core/service/auth.service';
 
@Directive({
  selector: '[appAppAccess]',
  standalone: true
})
export class AppAccessDirective {
 
  @Input() appAccess: string ="";
  user : any = {};
  constructor(private el: ElementRef, private authService: AuthService) {
  }
 
  ngOnInit() {
    this.user = this.authService.getCurrentUser();
    const user_fonctionnalites = this.authService.getFonctionnalites()

    this.el.nativeElement.style.display = 'none';
 
    const normalizedAccess = this.appAccess;
 
    console.log('normalizedAccess: ',normalizedAccess)
 
    let hasAcces =
      (user_fonctionnalites ?? []).some((o:any) =>
        o?.codification === normalizedAccess
      )
   
    // console.log("hasAcces: ",hasAcces)
    if (hasAcces) {
      this.el.nativeElement.style.display = '';
    }else {
      this.el.nativeElement.style.display = 'none';
    }
    // this.el.nativeElement.style.display = 'block';
  }
 
 
}
 
 